import {
  createContext,
  ReactNode,
  useContext,
  useMemo,
  useReducer,
} from "react";
import rowDataReducer from "../reducers/rowDataReducer/rowDataReducer";
import { DEFAULT_INITIAL_ROW_DATA_REDUCER_STATE } from "../reducers/reducerMocks";
import { RowDataContextProps } from "../types";

const RowDataContext = createContext<RowDataContextProps | undefined>(
  undefined,
);

export const RowDataProvider = ({
  children,
}: Readonly<{
  children: ReactNode;
}>): JSX.Element => {
  const [rowDataReducerState, dispatch] = useReducer(rowDataReducer, {
    ...DEFAULT_INITIAL_ROW_DATA_REDUCER_STATE,
  });

  const value = useMemo(
    () => ({ rowDataReducerState, dispatch }),
    [rowDataReducerState, dispatch],
  );

  return (
    <RowDataContext.Provider value={value}>{children}</RowDataContext.Provider>
  );
};

export const useRowDataContext = (): RowDataContextProps => {
  const context = useContext(RowDataContext);

  if (!context) {
    throw new Error("useRowDataContext must be used within RowDataProvider");
  }

  return context;
};
